import { Controller } from '@hotwired/stimulus'

// Keeps the submit button disabled until the input actually differs from its
// persisted value. Used by the webhook URL field so "Save" only lights up on
// a real change.
export default class extends Controller {
  static targets = ['input', 'submit']
  static values = { original: String }

  connect() {
    this.check()
  }

  check() {
    if (!this.hasInputTarget || !this.hasSubmitTarget) return

    const current = this.inputTarget.value.trim()
    this.submitTarget.disabled = current === this.originalValue.trim()
  }
}
